import React from 'react';

import { SiteContext } from '@/contexts/site-context';

import { formatPhoneNumber } from '@/helpers/helpers';

import * as styles from './index.module.scss';

const AccessibleContent = () => {
  const [site] = React.useContext(SiteContext);

  return (
    <div className={`${styles['accessible-view-container']}`}>
      <div className="container">
        <h2>Accessible View Page</h2>
        <p>
          <strong>(Last Updated: January 17, 2020)</strong>
        </p>
        <p>At CallAPro&trade; our mission is to connect consumers with local businesses.</p>
        <p>
          Welcome to CallAPro&trade;! If you would like more information on the services that we offer, please give us a call at {formatPhoneNumber(site.phone_number)}, or email us at
          contact@callapro.com. We are proud to offer a dedicated phone line that we created especially for people who may experience accessibility issues with our website. Our specially-trained staff
          will give your call first priority and will be happy to help you find local businesses for hire. We can also assist any hard of hearing users via email at{' '}
          <a href="mailto:contact@callapro.com">contact@callapro.com</a>, or on our live chat.
        </p>
        <h3>We&apos;re Here to Help!</h3>
        <p>
          Ready to search local businesses?! Just call our priority hotline at {formatPhoneNumber(site.phone_number)} between the hours of 9 AM and 5 PM Eastern Standard Time, 7 days a week.
          We&apos;ll be happy to talk you through your options, answer any questions that you have, and find the local business that is right for you. If you have auditory issues or are unable to call
          in, our customer service team will be happy to assist you via email at <a href="mailto:contact@callapro.com">contact@callapro.com</a>, or on our live chat.
        </p>
        <h3>About CallAPro&trade;</h3>
        <p>
          CallAPro&trade; is a fast-growing, performance-based advertising company with specialization in Home Services, Legal, Medical, and Insurance verticals. CallAPro&trade; has been at the
          forefront of the changing advertising industry as one of the only media companies offering businesses of all sizes a performance-based pricing model to support new customer acquisition.
        </p>
        <h3>Formal Complaints</h3>
        <p>We aim to respond to accessibility feedback within 5 business days, and to propose a solution within 10 business days.</p>
        <h3>What is this page all about?</h3>
        <p>
          CallAPro&trade; is committed to accessibility and constantly strives to ensure compliance with all applicable laws and guidelines. To ensure that our services are as easy to access as
          possible for all of our customers, we have created this page to highlight our key offerings and to guide you to our priority hotline {formatPhoneNumber(site.phone_number)} or our customer
          service email address (contact@callapro.com), where we can answer all of your questions. We&apos;re always open to feedback on the accessibility of our website, so please do not hesitate to
          share your experience with us. We look forward to serving you.
        </p>
      </div>
    </div>
  );
};

export default AccessibleContent;
